/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Affiliates_CtaInputs */

const en_directory_resources_affiliates_cta = /** @type {(inputs: Directory_Resources_Affiliates_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about affiliates`)
};

const zh_directory_resources_affiliates_cta = /** @type {(inputs: Directory_Resources_Affiliates_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`咨询推荐计划`)
};

/**
* | output |
* | --- |
* | "Ask about affiliates" |
*
* @param {Directory_Resources_Affiliates_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_affiliates_cta = /** @type {((inputs?: Directory_Resources_Affiliates_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Affiliates_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_affiliates_cta(inputs)
	return zh_directory_resources_affiliates_cta(inputs)
});
export { directory_resources_affiliates_cta as "directory.resources.affiliates.cta" }